import { FormattedMessage } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { useShortcutWithKeys } from '@sorare/core/src/hooks/useShortcutWithKeys';

type Props = {
  playingNextDay: boolean;
  setPlayingNextDay: (playingInNextDay: boolean) => void;
  bold?: boolean;
  useShortcut?: boolean;
};
export const PlayingNextDayFilter = ({
  playingNextDay,
  setPlayingNextDay,
  bold = false,
  useShortcut = false,
}: Props) => {
  const id = 'playing-in-next-day';

  const { Icon: UsedShortcutIcon } = useShortcutWithKeys(
    'h',
    () => setPlayingNextDay(!playingNextDay),
    [playingNextDay]
  );

  return (
    <SBHorizontal>
      <LabelM bold={bold} as="label" htmlFor={id}>
        <FormattedMessage
          id="PlayingNextDayFilter.label"
          defaultMessage="Playing in next 24h"
        />
        {!!useShortcut && UsedShortcutIcon}
      </LabelM>
      <Switch
        id={id}
        checked={playingNextDay}
        onChange={e => setPlayingNextDay(e.target.checked)}
      />
    </SBHorizontal>
  );
};
